jQuery(function($){
  //$('.video-ss').click(function(){
  //  openModal( $(this).attr('data-vimeo-id') );
  //});
  
  $('body').on('click', '.video-ss', function() {
    openModal( $(this).attr('data-vimeo-id') );
  });
  $('body').on('click', '.video-play-btn', function() {
    openModal( $(this).parent().find('.video-ss').attr('data-vimeo-id') );
  });

  function openModal(id) {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var videoRatio = 600 / 338;
    var videoWidth = windowWidth / videoRatio;
    var videoHeight = videoWidth / videoRatio;
    
    var html = '<div class="modal-overlay"></div>' +
      '<div class="video-modal">' +
        '<div class="video-modal-inner">' +
        '<iframe src="//player.vimeo.com/video/' + id + '?autoplay=1" width="'+videoWidth+'" height="'+videoHeight+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
          '<div class="modal-close"></div>' +
        '</div>' +
      '</div>';
    $('body').append(html);
    $('.video-modal').css({'margin-left':'-'+ videoWidth / 2 + 'px', 'margin-top':'-'+ videoHeight / 2 + 'px'});
    $('.video-modal-inner').css({'width': videoWidth + 'px', 'height': videoHeight + 'px'});
    $('.modal-close, .modal-overlay').click(function(){
      $('.modal-overlay').remove();
      $('.video-modal').remove();
    });
  }
});




  
  
